import { Button, Col, Divider, Empty, Flex, Form, notification, Popconfirm, Row } from "antd";
import { TypeAlunoEResponsavel } from "../../../../../Models/Domain/Pessoa/AlunoEResponsavel";
import { useVincularPorCpfResponsavel } from "../../../../../Services/Pessoa/AlunoResponsavelServices";
import { useContext } from "react";
import { SessaoARContext } from "../../../../Contexts/SessaoContext";
import { EnumTipoUsuario } from "../../../../../Models/Domain/AreaRestrita/Sessao";
import { Formatacoes } from "../../../../../Utils/Formatacao";
import { InputComReactIMask } from "../../../../../Components/InputComReactIMask";
import { extractorNomePessoa, TypeAluno } from "../../../../../Models/Domain/Pessoa/Aluno";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import { useWatch } from "antd/lib/form/Form";

interface IVinculoDeNovoResponsavelFormProps {
    aluno: TypeAluno,
    onSucesso?: () => void,
    onCancelar?: () => void
}
export const VinculoDeNovoResponsavelForm : React.FC<IVinculoDeNovoResponsavelFormProps> = ({
    onSucesso,
    onCancelar,
    ...props
}) => {
    const SessaoAR = useContext(SessaoARContext);

    const [form] = Form.useForm<TypeAlunoEResponsavel>();
    const documentoResponsavel = Form.useWatch(["responsavel", "pessoa", "cpf"], form);
    // const [form] = (formParam ?? formNovo) as [FormInstance<IVinculoDeNovoResponsavelParaResponsavelForm>];

    // const responsaveisAtuais_Query = useQuery({
    //     queryKey: ["AlunoService.listarResponsaveis<'responsavel'>", props.aluno.codigo],
    //     queryFn: () => props.aluno.codigo == undefined? Promise.reject() : AlunoService.listarResponsaveis<'responsavel'>(props.aluno.codigo),
    //     enabled: SessaoAR?.sessao?.tipoDeUsuario == EnumTipoUsuario.Responsavel && props.aluno.codigo != undefined,
    //     gcTime: 0
    // })

    // const responsaveis = responsaveisAtuais_Query.data?.data;

    // const [ cpfAlvo, setCPFAlvo ] = useState<string>();

    // const responsavelAlvo_Query = useQuery({
    //     queryKey: ["AlunoService.listarResponsaveis<'responsavel'>", cpfAlvo],
    //     queryFn: () => cpfAlvo == undefined? Promise.reject() : ResponsavelService.GET<'responsavel'>({cpf: cpfAlvo}),
    //     retry: false
    // })

    // const {
    //     mutate,
    //     isPending
    // } = useMutation({
    //     mutationKey: ["AlunoService.vincularResponsaveisPeloCPF"],
    //     mutationFn: (data:TypeAlunoEResponsavel) => AlunoService.vincularResponsaveisPeloCPF(data.aluno.codigo!, [data.cpf]),
    //     onSuccess() {
    //         form.resetFields();
    //         onSucesso?.();
    //         // setCPFAlvo(undefined);
    //         // responsaveisAtuais_Query.refetch()
    //     },
    //     onError(error, variables, context) {
    //         console.log("Erro: ", error, variables, context);
    //     },
    // });

    const {
        mutate,
        isPending
    } = useVincularPorCpfResponsavel({
        onSuccess() {
            form.resetFields();
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Vinculo realizado com sucesso."),
            });
            onSucesso?.();
        },
        onError(error, variables, context) {
        }
    })

    function cancelar(e:React.MouseEvent<HTMLElement>) {
        form.resetFields();
        onCancelar?.();
    }

    if (SessaoAR?.sessao?.tipoDeUsuario !== EnumTipoUsuario.Responsavel) return <Empty description="A sessão atual não corresponde a uma sessão do tipo responsável"/>;

    return (
        <Form<TypeAlunoEResponsavel>
            form={form}
            component={"div"}
            onFinish={mutate}
            layout="vertical"
            autoComplete="off"
        >
            <Row gutter={16} wrap>
                <Form.Item<TypeAlunoEResponsavel> name={["aluno"]} initialValue={props.aluno}></Form.Item>
                <Col xs={24}>
                    <Form.Item<TypeAlunoEResponsavel>
                        name={["responsavel", "pessoa", "cpf"]}
                        label={"CPF do responsável"}
                        normalize={Formatacoes.somenteDigitos}
                        rules={[
                            { required: true }
                            //{ pattern: /^\d{13}$/, message: "Formato do CPF inválido" },
                        ]}
                    >
                        <InputComReactIMask maskOptions={{ mask: "000.000.000-00" }} />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Divider />
                    <Flex justify="space-between">
                        <Button type="primary" danger htmlType="button" disabled={isPending} onClick={cancelar}>Cancelar</Button>
                        <Popconfirm
                            title={"Vincular responsável"}
                            description={<p style={{ textAlign : "center" }}>
                                Confirma a vinculação do responsável (CPF: {documentoResponsavel ?? "Não informado"}) 
                                <br />ao aluno {extractorNomePessoa(props.aluno.pessoa!)}? 
                                <br />* Esta operação não poderá ser desfeita.
                            </p>}
                            onConfirm={form.submit}
                            okButtonProps={{
                                loading : isPending
                            }}
                        >
                            <Button type="primary" htmlType="button" loading={isPending}>Vincular</Button>
                        </Popconfirm>
                    </Flex>
                </Col>
            </Row>
        </Form>
        // <Col xs={2}>
        //     <Button type="default" htmlType="submit" icon={<PlusOutlined />} style={{ width: "100%" }} />
        // </Col>
        // <div style={props.style}>
            //  <Row gutter={[8, 8]}>
            //     <Col xs={24}>
            //         <List
            //             header={
            //                 <Typography.Title level={4} style={{ margin: 0 }}>
            //                     Responsáveis vinculados <Tooltip title={<>Contate o suporte caso deseje realizar remoções</>}><QuestionCircleTwoTone/></Tooltip>
            //                 </Typography.Title>
            //             }
            //             dataSource={responsaveis ?? []}
            //             itemLayout="horizontal"
            //             renderItem={(item) => {
            //                 return (
            //                     <List.Item>
            //                         <Skeleton avatar loading={responsaveisAtuais_Query.isFetching || vincularNovoResponsavel.isPending} active paragraph={false}>
            //                             <List.Item.Meta
            //                                 avatar={<Avatar icon={<UserOutlined />} />}
            //                                 title={item.nome ?? "Não informado"}
            //                                 description={<>CPF: {item.cpf ?? "Não informado"}</>}
            //                             />
            //                         </Skeleton>
            //                     </List.Item>
            //                 );
            //             }}
            //         />
            //     </Col>
            // </Row> 

            

            // {responsavelAlvo_Query.isFetchedAfterMount && responsavelAlvo_Query.data?.data != undefined && (
            //     <Row>
            //         <Col xs={24}>
            //             <Spin spinning={responsavelAlvo_Query.isFetching}>
            //                 <Row gutter={[8, 16]}>
            //                     <Col xs={24}>
            //                         <Typography style={{ textAlign: "center" }}>
            //                             <Typography.Title level={4} style={{ marginTop: 0 }}>
            //                                 {" "}
            //                                 Confira os dados do novo responsável{" "}
            //                             </Typography.Title>

            //                             <Typography.Text strong>Nome: </Typography.Text>
            //                             <Typography.Text>{responsavelAlvo_Query.data?.data.at(0)?.nome}</Typography.Text>

            //                             <br />

            //                             <Typography.Text strong>CPF: </Typography.Text>
            //                             <Typography.Text>{responsavelAlvo_Query.data?.data.at(0)?.cpf}</Typography.Text>
            //                         </Typography>
            //                     </Col>

            //                     <Col xs={24} style={{ textAlign: "center" }}>
            //                         <Button
            //                             type="primary"
            //                             onClick={() => {
            //                                 Modal.confirm({
            //                                     title: "Tem certeza?",
            //                                     content: <>Esta ação é irreversível.</>,
            //                                     onOk: () => {
            //                                         if (props.aluno.codigo == undefined) return;
            //                                         if (cpfAlvo == undefined) return;

            //                                         vincularNovoResponsavel.mutate({ codigoDoAluno: props.aluno.codigo, cpf: cpfAlvo });
            //                                     },
            //                                 });
            //                             }}
            //                         >
            //                             Registrar vínculo
            //                         </Button>
            //                     </Col>
            //                 </Row>
            //             </Spin>
            //         </Col>
            //     </Row>
            // )}
        // </div>
    );
}
